import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';

import { createRentReceipt } from 'actions/tenantProfileActions';
import { submit, isSubmitting } from 'redux-form';

import PaymentsTable from '../PaymentsTable';

import RentReceiptGenerator from './RentReceiptGenerator';
import TenantReceiptDialog from '../TenantReceiptDialog';

import FlatButton from 'material-ui/FlatButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import YardiLedger from '../shared/YardiLedger';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

import { localize } from 'react-localize-redux';
import CtaPrimary from 'components/ui/CtaPrimary';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';

const StyledBalanceHeader = styled.div`
  background-color: ${(props) => (props.accentColor ? props.accentColor : colors.BLUE_DENIM)};
  padding: 24px 24px 20px;
  margin: 0 0 32px 0;
  position: relative;
`;

const StyledBalanceHeaderP = styled.p`
  color: #fff;
  text-align: center;
  margin-bottom: 5px;
`;

const StyledBalanceHeaderH1 = styled.h1`
  color: #fff;
  text-align: center;
  margin-top: 5px;
`;

const StyledButton = styled(CtaPrimary)`
  height: 40px;
  bottom: -40px;
  font-size: 12px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.15);
  padding-left: 30px;
  padding-right: 30px;
  color: ${(props) => (props.accentColor ? props.accentColor : colors.BLUE_DENIM)}
  background-color: #fff;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  display: block;
  position: absolute;
`;

let AllTransactions = withMobileDialog()(
  connect(
    (state) => ({
      paymentList: state.tenantProfile.payments,
      submitting: isSubmitting('rent_receipt')(state),
      landlordHasUploadedLogo: !!state.userTypes.landlordLogoUrl,
    }),
    { createRentReceipt, submit }
  )(
    class AllTransactions extends Component {
      constructor(props) {
        super(props);
        this.state = {
          filter: props.translate('transactions.filter.all').props.children,
          receiptDialogOpen: false,
          ledgerIsOpen: false,
          paymentDetails: {},
          expandedRows: [],
        };
      }

      toggleReceiptDialog = (paymentDetails) => {
        if (paymentDetails) {
          return this.setState({ receiptDialogOpen: true, paymentDetails });
        }

        this.setState({ receiptDialogOpen: false, paymentDetails: {} });
      };

      handleYardiRowClickIndex = (index) => {
        const currentExpandedRows = this.state.expandedRows;
        let newExpandedRows = [];
        if (currentExpandedRows.includes(index)) {
          newExpandedRows = currentExpandedRows.filter((i) => i !== index);
        } else {
          newExpandedRows = currentExpandedRows.concat(index);
        }
        this.setState({ expandedRows: newExpandedRows });
      };

      handleClose = () => {
        this.props.toggleDialog();
        this.setState({
          expandedRows: [],
        });
      };

      render() {
        return (
          <Fragment>
            {this.renderTenantPaymentDetailsDialog()}

            <TenantReceiptDialog
              isOpen={this.state.receiptDialogOpen}
              toggleDialog={this.toggleReceiptDialog}
              paymentDetails={this.state.paymentDetails}
              landlordHasUploadedLogo={this.props.landlordHasUploadedLogo}
            />

            {this.renderTenantPaymentHistoryDialog()}
          </Fragment>
        );
      }

      renderTenantPaymentDetailsDialog = () => (
        <Dialog
          disableBackdropClick
          fullScreen={this.props.fullScreen}
          open={this.state.ledgerIsOpen}
          onClose={() => {
            this.setState({ ledgerIsOpen: false });
          }}
          aria-labelledby="payment-receipt"
          classes={{
            paper: 'form-dialog',
          }}
        >
          <DialogTitle id="add-new-amenity">
            <h3 style={{ margin: '10px 0 5px', textAlign: 'center' }}>
              {this.props.translate('transactions.rentReceiptCreator')}
              <b style={{ fontFamily: 'Circular-Black', color: AccentColor() }}>.</b>
            </h3>
          </DialogTitle>
          <DialogContent>
            <p style={{ textAlign: 'center' }}>
              {this.props.translate('transactions.instructions')}
            </p>
            <RentReceiptGenerator onSubmit={this.props.createRentReceipt} />
          </DialogContent>
          <DialogActions style={{ display: 'block' }}>
            {this.renderTenantPaymentDetailsActions()}
          </DialogActions>
        </Dialog>
      );

      renderTenantPaymentDetailsActions = () => (
        <Fragment>
          <FlatButton
            onClick={() => {
              this.setState({ ledgerIsOpen: false });
            }}
            id="close-button"
            style={{ color: AccentColor(), textTransform: 'uppercase' }}
          >
            {this.props.translate('close')}
          </FlatButton>
          <FlatButton
            variant="raised"
            onClick={() => this.props.submit('rent_receipt')}
            disabled={this.props.submitting}
            id="submit-button"
            style={{
              color: 'white',
              backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
              textTransform: 'uppercase',
            }}
          >
            {this.props.translate('create')}
          </FlatButton>
        </Fragment>
      );

      renderTenantPaymentHistoryDialog = () => (
        <Dialog
          fullScreen={this.props.fullScreen}
          open={this.props.isOpen}
          onClose={this.handleClose}
          aria-labelledby="show-previous-rents"
          classes={{
            paper: 'form-dialog',
          }}
        >
          <StyledBalanceHeader
            onClick={this.props.ableToMakePayment ? this.props.handleMakePayment : null}
          >
            <StyledBalanceHeaderP accentColor={AccentColor()}>
              {getTranslatedString('transactions.accountBalance')}
            </StyledBalanceHeaderP>
            <StyledBalanceHeaderH1>{this.props.amountOwing}</StyledBalanceHeaderH1>
            {this.props.ableToMakePayment && (
              <StyledButton accentColor={AccentColor()}>
                {getTranslatedString('transactions.makePayment')}
              </StyledButton>
            )}
          </StyledBalanceHeader>
          <DialogContent>
            <Fragment>
              <div className="row" style={{ margin: '0', padding: '0 15px', textAlign: 'center' }}>
                <button
                  type="button"
                  className="link-button"
                  onClick={() => {
                    this.setState({ ledgerIsOpen: true });
                  }}
                >
                  {' '}
                  {this.props.translate('accessRentReceipt')}{' '}
                </button>
              </div>
              <div className="row" id="payments-table">
                {this.renderHistory()}
              </div>
            </Fragment>
          </DialogContent>
          <DialogActions style={{ display: 'block' }}>
            <FlatButton
              onClick={this.handleClose}
              id="close-button"
              style={{ color: AccentColor(), textTransform: 'uppercase' }}
            >
              {this.props.translate('close')}
            </FlatButton>
          </DialogActions>
        </Dialog>
      );

      renderHistory = () => {
        if (this.props.yardiBased) {
          return (
            <YardiLedger
              ledger={this.props.yardiLedger}
              handleRowClickIndex={this.handleYardiRowClickIndex}
              expandedRows={this.state.expandedRows}
              amountOwing={this.props.amountOwing}
              handleMakePayment={this.props.handleMakePayment}
            />
          );
        } else {
          return (
            <PaymentsTable data={this.props.paymentList} toggleDialog={this.toggleReceiptDialog} />
          );
        }
      };
    }
  )
);

export default localize()(AllTransactions);
